@if(!isCoke()){
    <div class="campaign-container">
        @if(!loading()){
            @if(config()){
                <picture>
                    @if(config().web_desktop_image; as desktop_image){
                        <source [srcset]="desktop_image | perf | bucket" media="(min-width: 900px)">
                        <source [srcset]="desktop_image | bucket" media="(min-width: 900px)">
                    }
                    @if(config().web_mobile_image; as mobile_image){
                        <source [srcset]="mobile_image | perf | bucket" media="(max-width: 900px)">
                        <source [srcset]="mobile_image | bucket" media="(max-width: 900px)">
                    }
                    <img class="image-banner" src="old/homev2/bigBanner.webp" alt="Campaign Artwork"/>
                </picture>
            }
            <div class="centered-small play-section">
                <a class="play-now font-extrabold" mat-raised-button routerLink="/builder" [queryParams]="queryParams()">PLAY NOW</a>
            </div>
            <div class="under-banner">
                <div class="instructions-container">
                    <div class="instructions">
    
                        @if(config()?.web_howto_image; as howto_image){
                            <img [src]="howto_image | bucket" alt="How to Play"/>
                        } @else {
                            <h1 class="mat-headline-2 part-title font-bold">How to Play</h1>
                        
                            <div class="steps">
                                <h1 class="m-0 num mat-headline-2 font-bold">1</h1>
                                <h4 class="m-0 instruction">Download the app and sign up/login to your account</h4>
                                <h1 class="m-0 num mat-headline-2 font-bold">2</h1>
                                <h4 class="m-0 instruction">Visit our Competitions Section on the cloudigo application</h4>
                                <h1 class="m-0 num mat-headline-2 font-bold">3</h1>
                                <h4 class="m-0 instruction">Try your luck and play for your chance to win</h4>
                            </div>
                        }
                    </div>
                </div>
                @if(prizeResult(); as result){
                    <div class="prizes">
                    
                        <div class="prizes-title-container">
                            <h1 bold class="mat-headline-2 part-title">Gifts to be Won</h1>
                        </div>
                    
                        <div class="prize-list-container">
                            <mat-tab-group mat-align-tabs="left" color="primary" dynamicHeight="true" (swipeleft)="swipe($event.type)" (swiperight)="swipe($event.type)" (animationDone)="animating.set(false)" [(selectedIndex)]="selectedIndex" (selectedIndexChange)="animating.set(true)">
                                @for(group of giftLists; track group.value){
                                    @if(result[group.value]?.length){
                                        <mat-tab [label]="group.key">
                                            <ng-template matTabContent>
                                                @if(!animating()){
                                                    <div class="tab-container">
                                                        <div class="prize-list">
                                                            @for(prize of result[group.value]; track prize._id){
                                                                <div class="prize-item">
                                                                    <img class="prize-logo" [src]="(prize.logo_url || prize.brand?.logo_url) | bucket" [alt]="(prize.brand?.name || 'cloudigo') + 'Prize'" [fallback]/>
                                                                    <p class="m-0 prize-brand-title font-bold">{{prize.brand?.short || prize.brand?.name || 'cloudigo'}}</p>
                                                                    <p class="m-0 prize-title">{{prize.title}}</p>
                                                                </div>
                                                            }
                                                        </div>
                                                    </div>
                                                }
                                            </ng-template>
                                        </mat-tab>
                                    }
                                }
                            </mat-tab-group>
                    
                        </div>
                    </div>
                }
                <div class="centered-small">
                    <a class="terms" routerLink="/promotional-terms" [fragment]="config()?.terms_web || 'generic-quiz'">Terms and conditions apply</a>
                </div>
            </div>
        } @else {
            <div class="svg-loader f-main-center py-30">
                <object data="/old/cloudigo_loader.svg" type="image/svg+xml"></object>
            </div>
        }
    </div>
} @else if(cokeUrl()) {
    <iframe [src]="cokeUrl()! | safe: 'resource'" frameborder="0"></iframe>
}